module.exports = __webpack_public_path__ + "static/media/leanpub.16829508.svg";